import { TradeOrgPages } from "../types/tradeorgPages.ts";
import List from "./components/List.tsx";
import OrgLinks from "./components/OrgLinks.tsx";
import Text from "./components/Text.tsx";
import Title from "./components/Title.tsx";
import { Layout } from "./Layout.tsx";

const Sweboat = () => {
  const pageName = TradeOrgPages.Sweboat;
  return (
    <Layout
      left={
        <>
          <Title title="För ett tryggt båtägande – anlita en Sweboatmedlem!" />
          <div className="mt-40 pb-40">
            <Text text="Sweboats medlemmar finns över hela landet och driver sina verksamheter året runt med Kunskap, Kvalitet, Köptrygghet som ledord." />
            <Text text="Sweboat har nära 400 företag inom marinbranschen som medlemmar." />
            <Text text="De bästa och mest pålitliga företagen i branschen har valt att ansluta sig." />
            <Text text="Det grundläggande kravet är seriositet." />
            <br />
            <List
              title="Det betyder bland annat:"
              listElements={[
                "Man har utbildning i och följer konsumentlagarna.",
                "Man säljer endast CE-märkta båtar.",
                "Man säljer varudeklarerade begagnade båtar.",
                "Man har en ansvarsförsäkring och en miljöpolicy.",
                "Man följer Allmänna Reklamationsnämndens rekommendationer vid en eventuell tvist.",
              ]}
            />
            <Text text="Allt för att du ska ha ett tryggt båtägande!" />
            <p className="mt-16 mb-0 text-m">
              <a href="https://www.sweboat.se/medlemmar" target="_blank" rel="noopener">
                Kolla om företaget är medlem i Sweboat
              </a>
            </p>
          </div>
        </>
      }
      right={<OrgLinks pageName={pageName} />}
    />
  );
};

export default Sweboat;
